import React, { useEffect, useReducer, useRef, ReactElement  } from "react";

// Interface for tag item
interface TagItem {
	title?: string;
	value?: string;
	count?: number;
}

// Interface for tag selector item with type
interface TagSelectorItem {
	type: string;
	title: string;
	value: string;
	version: string;
}

// Interface for component state
interface TagsSelectorState {
	title: string;
	list: TagItem[];
	suggested: TagItem[];
	autocomplete: TagItem[];
	possible: TagItem[];
	focused: boolean;
}

// Interface for component props
interface TagsSelectorProps {
	title?: string;
	list?: TagItem[];
	suggested?: TagItem[];
	possible?: TagItem[];
	iteration?: number;
	type?: string;
	onChange?: (list: TagSelectorItem[]) => void;
}

const TagsSelectorReducer = function( state: TagsSelectorState, [ type, data ]: [string, wts_ignore_any] ): TagsSelectorState {

	if( type === "focus" ){
		return {
			...state,
			focused: !!data.value
		};
	}else if( type === "autocomplete" ){

		let list: TagItem[] = [];

		if( data.value ){

			for( const item of state.possible ){

				if( (item.title || "")
					.toLocaleLowerCase()
					.indexOf( (data.value || "").toLocaleLowerCase() ) < 0 )
					continue;

				list.push( item );
			};

		};

		return {
			...state,
			autocomplete: list
		};
	}else if( type === "list" ){

		let list = [ ...data ];

		for( let item of list ){

			if( !item.value )
				continue;

			if( !item.title )
				item.title = item.value;

		};

		if( !list.length )
			list.push({ title: "All", value: "" });

		return {
			...state,
			list: list
		};
	}else if( type === "possible" ){

		let table: { [key: string]: boolean } = {};
		let list: TagItem[] = [];

		for( const item of data ){

			if( table[ item.value ] )
				continue;

			list.push( item );
			table[ item.value ] = true;
		};

		return {
			...state,
			possible: list
		};
	}else if( type === "suggested" ){

		let table: { [key: string]: boolean } = {};
		let list: TagItem[] = [];

		for( const item of data ){

			if( table[ item.value ] )
				continue;

			list.push( item );
			table[ item.value ] = true;
		};

		return {
			...state,
			suggested: list
		};
	}else if( type === "add" ){

		let list = [ ...state.list ];

		if( list[ 0 ] && !list[ 0 ].value )
			list.shift();

		let a = state.autocomplete[ 0 ] || null;

		if( a ){

			let f = list.find(( item ) => item.value === a.value );

			if( !f )
				list.push({ ...a });

		}else{

			//if( !list.find(( item ) => item.value === data.value ) )
			//	list.push({ title: data.value, value: data.value });

		};

		if( !list.length )
			list.push({ title: "All", value: "" });

		return {
			...state,
			list: list,
			autocomplete: (data.clearAutocomplete ? [] : state.autocomplete)
		};
	}else if( type === "toggle" ){

		let list = [ ...state.list ];

		if( list[ 0 ] && !list[ 0 ].value )
			list.shift();

		let index = list.findIndex(( item ) => item.value === data.value );

		if( index < 0 )
			list.push({ title: data.title, value: data.value });
		else{
			list.splice( index, 1 );
		};

		if( !list.length )
			list.push({ title: "All", value: "" });

		return {
			...state,
			list: list
		};
	};

	return state;
};

const TagsSelectorSuggestionItem = function( state: TagsSelectorState, dispatch: React.Dispatch<[string, wts_ignore_any]>, item: TagItem ): ReactElement {
	return (
		<div
			className={"tselector-suggestions-item"	+ (state.list.find(( f ) => f.value === item.value  ) ? " tselector-suggestions-item-selected" : "")}
			key={ item.value }
			onClick={() => dispatch([ "toggle", { value: item.value, title: item.title } ]) }
		>
		<svg className={ "tselector-suggestions-item-checkbox" } viewBox="0 0 24 24">
			<path d="M6.445 12.668a.9.9 0 00-1.303
					1.242l3.573 3.745a.9.9 0 001.335-.036l8.591-10.037a.9.9
					0 00-1.367-1.17l-7.656 8.944a.4.4 0 01-.593.016l-2.58-2.704z"></path>
		</svg>
		<div className={ "tselector-suggestions-item-title" }>{ item.title }</div>
		<div className={ "tselector-suggestions-item-count" }>( { item.count } )</div>
	</div>);
};

export const TagsSelector = ( props: TagsSelectorProps ) => {

	const [ state, dispatch ] = useReducer( TagsSelectorReducer, {
		title: props.title || "",
		list: [{ title: "All", value: "" }],
		suggested: props.suggested || [],
		autocomplete: [],
		possible: props.possible || [],
		focused: false
	});

	useEffect(() => {
		dispatch([ "list",  props.list || [{ title: "All", value: "" }] ]);
	}, [ props.iteration ]);

	useEffect(() => {
		dispatch([ "suggested",  props.suggested || [] ]);
	}, [ props.suggested ]);
	useEffect(() => {
		dispatch([ "possible",  props.possible || [] ]);
	}, [ props.possible ]);

	useEffect(() => {

		if( !props.onChange )
			return;

		let list: TagSelectorItem[] = [];

		for( let item of state.list ){

			if( !item.value )
				continue;

			list.push({ type: (props.type || ""), title: item.title!, value: (item.value || ""), version: "" });
		};

		props.onChange( list );

	}, [ state.list ]);

	const input = useRef<HTMLInputElement>( null );
	const timeout = useRef<NodeJS.Timeout | number>( 0 );

	return (
		<div className={ "tselector" + (state.focused ? " " : " tselector-closed") }>
			<div className={ "tselector-input" } onClick={() => {

				if( state.focused || !input.current )
					return;

				input.current.focus();

			}}>
				<div className={ "tselector-list" }>
				{
					state.list.map(( item: TagItem ) => {
						return (
							<div className={ "tselector-elem" } key={ item.value }>
								<div className={ "tselector-elem-text" }>{ item.title }</div>
								<div className={ "tselector-elem-remove" + (!item.value ? " hidden" : "") }
									onClick={() => dispatch([ "toggle", { value: item.value } ]) }
								>x</div>
							</div>
						);
					})
				}
				</div>
				<input
					ref={ input }
					onFocus={() => dispatch([ "focus", { value: true } ]) }
					onBlur={() => dispatch([ "focus", { value: false } ]) }
					onKeyDown={( event: React.KeyboardEvent<HTMLInputElement> ) => {

						if( timeout.current )
							clearTimeout( timeout.current );

						if( event.keyCode === 13 ){
							const target = event.target as HTMLInputElement;
							dispatch([ "add", { value: target.value, clearAutocomplete: true } ]);
							target.value = "";
						}else{
							timeout.current = setTimeout(() => {
								const target = event.target as HTMLInputElement;
								dispatch([ "autocomplete", { value: target.value } ]);
							}, 100 );
						};
					}}
				/>
			</div>
			<div className={ "tselector-suggestions" }
				 onMouseDown={( event: React.MouseEvent ) => {
					event.preventDefault();
				}}>

				<div className={ "tselector-suggestions-section" + (state.autocomplete.length ? "" : " hidden") }>
					<div className={ "tselector-suggestions-title" }>{ "Autocomplete" }</div>
					<div className={ "tselector-suggestions-list" }>
						{
							state.autocomplete.map(( item: TagItem ) => {
								return TagsSelectorSuggestionItem( state, dispatch, item );
							})
						}
					</div>
				</div>

				<div className={ "tselector-suggestions-section" }>
					<div className={ "tselector-suggestions-title" }>{ "Suggestions" }</div>
					<div className={ "tselector-suggestions-list" }>
					{
						state.suggested.map(( item: TagItem ) => {
							return TagsSelectorSuggestionItem( state, dispatch, item );
						})
					}
					</div>
				</div>

			</div>
		</div>
	);
};